import React, { useState, useContext } from "react";

import MenuItem from "@material-ui/core/MenuItem";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Menu,
  TextField,
} from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import toastError from "../../errors/toastError";

const MessageOptionsMenu = ({
  message,
  menuOpen,
  handleClose,
  anchorEl,
}) => {
  const { setReplyingMessage } = useContext(ReplyMessageContext);

  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [editBody, setEditBody] = useState("");
  const [editing, setEditing] = useState(false);

  const handleDeleteMessage = async () => {
    try {
      await api.delete(`/messages/${message.id}`);
    } catch (err) {
      toastError(err);
    }
  };

  const handleEditMessage = async () => {
    const body = editBody.trim();

    if (!body) return;

    if (body === message.body) {
      setEditOpen(false);
      return;
    }

    setEditing(true);

    try {
      await api.put(`/messages/${message.id}`, { body });
      setEditOpen(false);
    } catch (err) {
      toastError(err);
    } finally {
      setEditing(false);
    }
  };

  const handleReplyMessage = () => {
    setReplyingMessage(message);
    handleClose();
  };

  const handleOpenConfirmationModal = () => {
    setConfirmationOpen(true);
    handleClose();
  };

  const handleOpenEditModal = () => {
    setEditBody(message.body || "");
    setEditOpen(true);
    handleClose();
  };

  const handleCloseEditModal = () => {
    if (!editing) setEditOpen(false);
  };

  return (
    <>
      <ConfirmationModal
        title={i18n.t(
          "messageOptionsMenu.confirmationModal.title"
        )}
        open={confirmationOpen}
        onClose={setConfirmationOpen}
        onConfirm={handleDeleteMessage}
      >
        {i18n.t(
          "messageOptionsMenu.confirmationModal.message"
        )}
      </ConfirmationModal>

      <Dialog
        open={editOpen}
        onClose={handleCloseEditModal}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Editar mensagem</DialogTitle>

        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            multiline
            rows={3}
            rowsMax={10}
            margin="dense"
            variant="outlined"
            value={editBody}
            disabled={editing}
            onChange={(event) => setEditBody(event.target.value)}
            onKeyDown={(event) => {
              if (
                event.key === "Enter" &&
                !event.shiftKey &&
                editBody.trim() &&
                !editing
              ) {
                event.preventDefault();
                handleEditMessage();
              }
            }}
          />
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleCloseEditModal}
            disabled={editing}
          >
            Cancelar
          </Button>

          <Button
            color="primary"
            variant="contained"
            onClick={handleEditMessage}
            disabled={
              editing ||
              !editBody.trim() ||
              editBody.trim() === message.body
            }
          >
            Salvar
          </Button>
        </DialogActions>
      </Dialog>

      <Menu
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={menuOpen}
        onClose={handleClose}
      >
        {message.fromMe &&
          !message.isDeleted &&
          !message.mediaUrl && (
            <MenuItem onClick={handleOpenEditModal}>
              Editar
            </MenuItem>
          )}

        {message.fromMe && (
          <MenuItem onClick={handleOpenConfirmationModal}>
            {i18n.t("messageOptionsMenu.delete")}
          </MenuItem>
        )}

        <MenuItem onClick={handleReplyMessage}>
          {i18n.t("messageOptionsMenu.reply")}
        </MenuItem>
      </Menu>
    </>
  );
};

export default MessageOptionsMenu;
